import { axiosInstance } from 'api/apiConfig'
import { useQuery, useMutation } from 'react-query'

const menurecipInfo = async (params) => {
  const { data } = await axiosInstance.post('api/menucrte/menurecp/v1.0/menuRecip',params)
  return data
}

// 메뉴&레시피
export const useMenurecipInfo = (params, isInit) => {
  return useQuery(
    ['menurecipInfo'],
    () => menurecipInfo(params),
    {
      enabled: isInit,
    },
  )
}

const menurecipCombo = async (params) => {
  const { data } = await axiosInstance.post('api/menucrte/menurecp/v1.0/menuRecipCombo',params)
  return data
}

// 메뉴&레시피 사이트레시피콤보
export const useMenurecipCombo = (params, isInit) => {
  return useQuery(
    ['menurecipCombo'],
    () => menurecipCombo(params),
    {
      enabled: isInit,
    },
  )
}



//메뉴&레시피 이미지저장
const addMenurecipImage = async (params) => {
  const { data } = await axiosInstance.post('api/menucrte/menurecp/v1.0/addSiteMenuImage', params)
  return data
}

export const useAddMenurecipImage = ({ successHandler, errorHandler }) => {
  return useMutation((params) => addMenurecipImage(params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}